<template>
  <div class="container">
    <loading
      :active.sync="isLoading"
      :loader="'dots'"
      :color="'#FFF'"
      :background-color="'#000'"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="row">
      <div class="logo">
        <img src="monorevo_logo_fix-black.svg" />
      </div>
    </div>
    <div class="row">
      <form class="w-100" @submit.prevent="login">
        <div class="card mb-3">
          <div class="card-header">
            <h4>{{ $t("ログイン")}}</h4>
          </div>

          <div class="card-body">
            <div class="form-group">
              <label for="inputCompany">{{ $t("会社ID（メールアドレス）") }}</label>
              <input
                type="email"
                name="email"
                class="form-control"
                autofocus
                required
                id="inputCompany"
                v-model="company_id"
              />
            </div>
            <div class="form-group">
              <label for="inputLoginId">{{ $t("ログインID") }}</label>
              <input
                type="text"
                name="login_id"
                id="inputLoginId"
                class="form-control"
                autofocus
                maxlength="50"
                v-model="login_id"
                required
              />
            </div>
            <div class="form-group">
              <label for="inputPassword">{{ $t("パスワード") }}</label>
              <input
                type="password"
                name="password"
                id="inputPassword"
                class="form-control"
                v-model="password"
                required
              />
            </div>
            <div
              class="alert alert-danger"
              role="alert"
              v-show="loginError"
            >{{ $t("ログイン失敗") }}</div>
            <div class="login-btn">
              <button class="btn btn-lg btn-success btn-block" type="submit">
                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                &nbsp;{{ $t("ログイン") }}
              </button>
            </div>
            <div class="small">
              <p @click="mixinTransition('/auth/lostpassword.html')" class="resetLink">
                <font-awesome-icon :icon="['fas', 'caret-right']" />
                {{ $t("パスワードを忘れた場合") }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
    <redirect ref="redirect" :immediately="false" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'login',

  data() {
    return {
      loginError: false,
      isLoading: false,
      company_id: '',
      login_id: '',
      password: '',
      pageTitle: 'ログイン',
    }
  },
  mounted() {
    // this.$store.dispatch('auth/user').then(res => {
    //   console.log(res)
    // })
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  computed: {
    ...mapGetters({
      userdata: 'auth/userdata',
    }),
  },
  methods: {
    ...mapActions({
      user: 'auth/user',
    }),
    async login() {
      this.isLoading = true
      this.loginError = false
      // ログインボタン押したらここを呼ぶ。
      // オブジェクトに、credentialを渡す（会社IDとユーザーID、パスワード）
      const credentials = {
        company_id: this.company_id,
        login_id: this.login_id,
        password: this.password,
      }

      const self = this
      this.$store
        .dispatch('auth/login', credentials)
        .then(async() => {
          await this.user()
          localStorage.setItem(
            '__monorevo.login.info',
            JSON.stringify({
              login_user_id: self.login_id,
              login_company_id: self.company_id,
              member_id: self.userdata.id,
              isSendedLoginEvent: false,
            })
          )
          await this.$refs.redirect.redirect()
        })
        .catch(() => {
          this.loginError = true
          this.isLoading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.resetLink {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
}
@import '../../assets/styles/common-page.scss';
</style>
